import React, { useState } from 'react';
import PropTypes           from 'prop-types';
import { IoCloseSharp, IoEyeOff, IoEye } from 'react-icons/io5';
import logoPng             from '../../assets/truscan_logo.png';
import './AuthModal.scss';

export default function AuthModal({ mode, onClose, onSuccess }) {
  const isLogin = mode === 'login';

  /* stages: 0=email, 1=password, 2=confirm (create only) */
  const [step, setStep] = useState(0);
  const [email, setEmail] = useState('');
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');

  const next = () => {
    /* validation */
    if (step === 0 && !email.trim()) { setError('Please Enter Email'); return; }
    if (step === 1 && !pw.trim())    { setError('Please Enter Password'); return; }
    if (!isLogin && step === 2 && pw2 !== pw) { setError('Passwords do not match'); return; }

    setError('');
    // if ((isLogin && step === 1) || (!isLogin && step === 2)) {
    //   alert(`Submit ${mode} → Email:${email} Pw:${pw}`);
    //   onClose();
    // } else {
    //   setStep(step + 1);
    // }
    const isLast = (isLogin && step === 1) || (!isLogin && step === 2);
    if (isLast) {
      // TODO: replace with real API request
      onSuccess();   // bubble up to AuthLanding → App.js
    } else {
      setStep(step + 1);
    }
  };

  /* field render helpers */
  const InputField = ({ type, value, onChange, placeholder }) => (
    <div className={`input-wrap ${error ? 'err' : ''}`}>
      <input
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        autoFocus
      />
      {type === 'password' && (
        <button
          className="eye"
          onClick={() => setShowPw(!showPw)}
        >
          {showPw ? <IoEye /> : <IoEyeOff />}
        </button>
      )}
    </div>
  );

  return (
    <div className="auth-modal">
      <button className="modal-close" onClick={onClose}>
        <IoCloseSharp />
      </button>

      <div className="modal-card">
        <img src={logoPng} alt="logo" className="logo" />
        <h2>{isLogin ? 'LOG IN' : 'CREATE ACCOUNT'}</h2>

        {/* email */}
        {step === 0 && (
          <>
            <InputField
              type="email"
              value={email}
              onChange={setEmail}
              placeholder="Email"
            />
          </>
        )}

        {/* password */}
        {step === 1 && (
          <>
            <InputField
              type={showPw ? 'text' : 'password'}
              value={pw}
              onChange={setPw}
              placeholder="Password"
            />
          </>
        )}

        {/* confirm password (create only) */}
        {!isLogin && step === 2 && (
          <>
            <InputField
              type={showPw ? 'text' : 'password'}
              value={pw2}
              onChange={setPw2}
              placeholder="Confirm Password"
            />
          </>
        )}

        {error && <p className="helper err">{error}</p>}

        {isLogin && step === 0 && (
          <p className="helper">forget password?</p>
        )}

        <button className="ghost-btn" onClick={next}>
          {isLogin ? (step === 0 ? 'NEXT' : 'LOG IN')
                   : (step < 2 ? 'NEXT' : 'CREATE')}
        </button>
      </div>
    </div>
  );
}

AuthModal.propTypes = {
  mode   : PropTypes.oneOf(['login', 'create']).isRequired,
  onClose: PropTypes.func.isRequired
};
